<template>
  <div>
    <div class="container">
      <div class="cardForm">
        <h2>{{ parseTranslation(RATE_CARDS) }}: {{ rateCardName }}</h2>

        <form action="">
          <div>
            <div class="items">{{ parseTranslation(CURRENCY) }}:*</div>

            <dropdown
              dropId="language"
              :width="200"
              :options="currencyDrop.options"
              :value="currencyDrop.currency"
              @update="data => (currencyDrop.currency = data)"
              :topEditCards="true"
            >
              <template v-slot:btn="slotProps">
                <div
                  :class="{
                    active: slotProps.opened || slotProps.hover,
                  }"
                  class="drop-language choose-drop"
                >
                  <p>
                    {{ currencyDrop.currency.text }}
                  </p>

                  <ArrowDrop />
                </div>
              </template>
            </dropdown>
          </div>

          <div>
            <div class="titleCards items">{{ parseTranslation(CARDS) }}:*</div>

            <div class="cards" v-for="(card, cardIndex) in cards" :key="cardIndex">
              <div class="content">
                <div class="items">
                  <div>
                    <label>{{ parseTranslation(MIN) }}:*</label>

                    <input
                      v-model="card.min"
                      class="inputRateCard"
                      type="number"
                      name="card.min"
                      min="0"
                      :max="card.max"
                      disabled
                    />
                  </div>
                  <div>
                    <label>CPC:*</label>

                    <input
                      @change="validCpc(cardIndex)"
                      v-model="card.cpc"
                      class="inputRateCard"
                      type="number"
                      name="card.cpc"
                      min="0.1"
                      :disabled="cardIndex !== lastCardsIndex"
                    />
                  </div>

                  <div>
                    <label>{{ parseTranslation(MAX) }}:*</label>

                    <input
                      @change="validMax(cardIndex)"
                      v-model="card.max"
                      :class="{ nullMax: !card.max }"
                      class="inputRateCard"
                      type="number"
                      name="card.max"
                      :min="card.min + 1"
                      :disabled="cardIndex !== lastCardsIndex"
                    />

                    <label
                      v-if="cardIndex === lastCardsIndex && validateMax"
                      class="validConditions"
                      >{{ parseTranslation(VALID_MAX) }}</label
                    >
                  </div>
                </div>

                <div class="delete">
                  <button
                    type="button"
                    class="add-card delete-card"
                    @click="deleteCard(cardIndex)"
                    v-if="cardIndex === lastCardsIndex && cardIndex"
                  >
                    <img src="@/assets/imgs/trash_add_card.svg" alt="" />
                  </button>
                </div>
              </div>

              <div class="add">
                <button
                  v-if="cardIndex === lastCardsIndex"
                  type="button"
                  class="add-card"
                  @click="addCard(card, cardIndex)"
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <div class="saveBtn">
            <button @click.prevent="editRateCard">
              <span v-if="loader"> <Loader color="#fff"/></span>

              <span v-else> {{ parseTranslation(SAVE_RATE_CARDS) }} </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getLastIndex } from '@/utils/array'
import { UNITARY_SHIFT } from '@/utils/constants'

import { mapActions } from 'vuex'

import Dropdown from '@/components/Dropdown.vue'
import Loader from '@/components/loading/Loader-3'

import ArrowDrop from '@/components/imgs/ArrowDropSelect'

import * as translationAddRateCards from './index.translations'
const { default: translations, ...translationKeys } = translationAddRateCards

export default {
  name: 'EditRateCards',

  props: ['getRateCards'],

  components: {
    Dropdown,
    Loader,
    ArrowDrop,
  },

  data() {
    return {
      translations,
      ...translationKeys,

      loader: false,
      currency: '',
      cards: [
        {
          min: 0,
          max: null,
          cpc: 0.1,
        },
      ],
      validCPC: false,
      currencyDrop: {
        currency: {
          value: 'Choose',
          text: 'Choose',
        },
        options: [
          {
            value: 'Choose',
            text: 'Choose',
          },
          {
            value: 'USD',
            text: 'USD',
          },
          {
            value: 'BRL',
            text: 'BRL',
          },
          {
            value: 'COP',
            text: 'COP',
          },
          {
            value: 'CLP',
            text: 'CLP',
          },
          {
            value: 'ARS',
            text: 'ARS',
          },
          {
            value: 'MXN',
            text: 'MXN',
          },
        ],
      },

      validateMax: false,
    }
  },

  computed: {
    rateCardName() {
      return this.$route.query.rc_name
    },

    lastCardsIndex() {
      return getLastIndex(this.cards)
    },
  },

  watch: {
    rateCardName() {
      this.loadGroup()
      this.scrollToTop()
    },

    max() {
      if (this.cards.max <= this.cards.min) {
        this.cards.max = this.cards.min + UNITARY_SHIFT
      }
    },
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    validCpc(index) {
      if (this.cards[index].cpc < 0.1) {
        this.cards[index].cpc = 0.1
      }
    },

    validMax(index) {
      if (this.cards[index].max <= this.cards[index].min && this.cards[index].max) {
        this.cards[index].max = this.cards[index].min + UNITARY_SHIFT
      }
    },

    addCard(addCards, index) {
      if (!this.cards[index].max) return (this.validateMax = true)
      else this.validateMax = false

      this.cards.push({
        min: +addCards.max + UNITARY_SHIFT,
        max: null,
        cpc: 0.1,
      })
    },

    deleteCard(index) {
      this.cards.splice(index, 1)
      this.validateMax = false
    },

    async loadGroup() {
      if (this.$store.getters.accType !== 'Root') return

      const card = await this.executeSurveyAPICall({
        path: 'rate-cards',
        queryParams: { rate_card: this.rateCardName },
      })

      if (!card) return

      this.currencyDrop.currency = {
        value: card.currency,
        text: card.currency,
      }

      this.cards = card.cards
    },

    async editRateCard() {
      if (this.loader) return

      this.loader = true

      const canEdit =
        this.currencyDrop.currency.value !== 'Choose' &&
        this.cards.filter(card => card.cpc).length

      if (!canEdit)
        return (
          this.sendMessage(this.translations[this.language][this.REQUIRED_FIELDS]),
          (this.loader = false)
        )

      const rateCards = await this.executeSurveyAPICall({
        method: 'PUT',
        path: 'rate-cards',
        payload: {
          currency: this.currencyDrop.currency.text,
          rate_card: this.rateCardName,
          cards: this.cards,
        },
      })

      if (!rateCards) return (this.loader = false)

      this.sendMessage(this.translations[this.language][this.CHANGES_SAVED])
      this.getRateCards()

      this.$router.push({
        name: 'addRateCards',
      })
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
  },

  created() {
    this.scrollToTop()

    this.loadGroup()
  },
}
</script>

<style lang="scss" scoped>
.cardForm {
  margin-top: 60px;
  @include tipography(16);
  form {
    display: block;
    flex-wrap: wrap;
  }

  h2 {
    @include tipography(20);
    font-weight: bold;
    margin-bottom: 30px;
  }

  .saveBtn {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    button {
      background: $blue;
      border: none;
      border-radius: 3px;
      padding: 10px 20px;
      @include tipography(15);
      letter-spacing: 3px;
      text-transform: uppercase;
      font-weight: bold;
      cursor: pointer;
      &:focus {
        outline: none;
      }
    }
  }

  .selectCurrency {
    color: #fff;
    font-weight: 500;
    width: 200px;
    height: 38px;
    font-size: 16px;
    border: 0.5px solid #fff;
    padding: 8px 10px;
    border-radius: 3px;
    background: transparent;
    cursor: pointer;
    margin: 20px 0;
    &:focus {
      outline: none;
    }
    color: #fff;
    option {
      padding: 10px 0 !important;
      color: $gray-6;
      background: #fcfcfc;
      border: 0.5px solid #0695fd;
      font-size: 14px;
    }
    .light & {
      color: $gray-6;
      background-color: #fcfcfc;
      border: 0.5px solid $gray-5;
    }
  }

  .light & {
    color: $gray-6;
    h2,
    input {
      color: $gray-6;
    }
  }

  input {
    width: 100%;
    display: block;
    margin: 10px 0 20px;
    @include tipography(16);
    color: #fff;
    background: none;
    border: 1px solid $gray-5;
    padding: 8px 10px;
    border-radius: 3px;
    &:focus {
      outline: none;
    }
    .light & {
      color: $gray-6;
    }
  }

  .inputRateCard {
    width: 100%;
    display: block;
    margin: 10px 0 20px;
    @include tipography(16);
    color: #fff;
    background: none;
    border: 1px solid $gray-5;
    padding: 8px 15px;
    border-radius: 3px;
    &:focus {
      outline: none;
    }
    .light & {
      color: $gray-6;
      &.nullMax {
        background: $gray-light-5;
      }
    }
    &.nullMax {
      background: $main-3;
    }
  }

  .validConditions {
    @include tipography(15);
    color: red;

    .ligth & {
      .validConditions {
        color: red;
      }
    }
  }

  .titleCards {
    margin: 20px 0;
  }

  .cards {
    margin: 0 0 50px 15px;
    display: flex;
    align-items: center;
    .content {
      background: $gray-10;
      width: 400px;
      padding: 30px 20px 30px;
      border-radius: 3px;
      display: flex;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
      align-items: center;
      .light & {
        background: $gray-light-9;
      }
      .items {
        min-width: 200px;
      }
      .delete {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .add {
    margin-left: 50px;
  }

  .add-card {
    background: $blue;
    color: $white;
    border: none;
    border-radius: 3px;
    width: 35px;
    height: 35px;
    font-weight: 700;
    font-size: 2rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center !important;
    &:focus {
      outline: none;
    }
    img {
      height: 23px;
    }
  }
}

.choose-drop {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #fff;
  border-radius: 3px;
  padding: 10px;
  cursor: pointer;

  img {
    width: 11px;
    height: 11px;
  }
  .light & {
    border: 1px solid $gray-5;
    color: $gray-6;
  }
}
</style>
